<template>
    <div>
        <inertia-link v-if="href"
           :href="href"
           class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
           role="menuitem"
           @click="clicked"
        >
            <slot></slot>
        </inertia-link>

        <span v-else
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition cursor-pointer"
              role="menuitem"
              @click="clicked"
        >
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'BaseDropdownLink',

    props: {
        href: {
            type: String,
        },
    },

    methods: {
        clicked() {
            this.$emit('clicked');
        },
    },
};
</script>
